import React from "react";

export default function VideoAndMap() {
  return (
    <section className="bg-black" data-testid="video-map-section">
      <div className="grid md:grid-cols-2">
        <div className="aspect-video w-full" data-testid="hoagie-video">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/DelkD4kydvQ?rel=0"
            title="Italian Hoagie"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ minHeight: 360 }}
          />
        </div>
        <div className="sd-location-card" data-testid="new-store-map">
          <img
            src="/images/mapmarker2.jpg"
            alt="Map of new store"
          />
          <div className="sd-location-overlay" />
          <div className="location-info ml-8">
            <h2>NEW STORE:</h2>
            <p className="text-white text-lg">7279 Rochester Rd</p>
            <p className="text-white text-lg">Lockport, New York 14094 USA</p>
            <p className="text-white text-lg mt-2">(716) 438-7183</p>
          </div>
        </div>
      </div>
    </section>
  );
}
